import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

dayjs.tz.setDefault('EST')

const config = {
  apiUrl: import.meta.env.VITE_APP_API_URL,
}

export default config
